export enum Credentials {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  MALFORMED_TOKEN = 'MALFORMED_TOKEN',
  DEVICE_ID_NOT_INFORMED = 'DEVICE_ID_NOT_INFORMED',
  INVALID_MINIMUM_CHARACTERS_PASSWORD = 'INVALID_MINIMUM_CHARACTERS_PASSWORD',
  CODE_MISMATCH_EXCEPTION = 'CODE_MISMATCH_EXCEPTION'
}
